import React, { useEffect, useState } from "react";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import { useTranslation } from "locales";
import useAuthUser from "hooks/useAuthUser";
import { getProduceStreams } from "lib/liveStreamHelpers";
import { MediaConstraints, MediaDevicePermissions, ProduceStream, ProduceUser } from "types";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import ChatTimer from "components/ChatTimer";
import LiveChatShare from "components/LiveChatShare";
import ModalWindow from "components/ModalWindow";
import StreamView from "components/StreamView";
import "./style.scss";

interface Props {
  produce: boolean;
  produceUser: UserPublicData | null;
  threadId: string | undefined;
  loading: boolean;
  userList: LiveChatUser[];
  streamStartedDate: string;
  onClose: () => void;
  token: string;
  showConfirmationExit: boolean;
  audioInputs?: MediaDeviceInfo[];
  videoInputs?: MediaDeviceInfo[];
  managedConstraints: MediaConstraints | null;
  onChangeConstraints?: (constraints: MediaConstraints) => void;
  permissions?: MediaDevicePermissions;
  disableAttachments?: boolean;
  me: ProduceUser | null;
  users: ProduceUser[];
  userListIcon?: string;
  onItemIconClick?: () => void;
  enableUserSearch?: boolean;
}

export default function PublicStreamView({ me, users, ...props }: Props) {
  const { user: authUser } = useAuthUser();
  const { t } = useTranslation();
  const [showShare, setShowShare] = useState(false);
  const [streams, setStreams] = useState<ProduceStream[]>([]);

  useEffect(() => {
    const result: ProduceStream[] = [];
    if (me) {
      result.push(...getProduceStreams(me));
    }
    users.forEach((user) => result.push(...getProduceStreams(user)));
    setStreams(result);
  }, [me, users]);

  const slotTimer = (
    <ChatTimer showTimeIfNegative streamStartedDate={props.streamStartedDate}>
      {"Live chat"}
    </ChatTimer>
  );

  const slotHeaderButtons = authUser ? (
    <BaseButton className="public-stream-view__btn __share" name={"share"} onClick={() => setShowShare(true)}>
      <BaseIcon className="public-stream-view__btn-icon">share</BaseIcon>
    </BaseButton>
  ) : undefined;

  const slotContentConfirmationExit = (
    <h1 className="headline-1 text-center">{t("Do you want to end the live chat?")}</h1>
  );

  return (
    <>
      {authUser && props.produceUser && (
        <ModalWindow show={showShare} onClose={() => setShowShare(false)} className="public-stream-view__share-modal">
          <LiveChatShare produce={props.produce} produceUser={props.produceUser} />
        </ModalWindow>
      )}

      <StreamView
        {...props}
        slotTimer={slotTimer}
        slotHeaderButtons={slotHeaderButtons}
        slotContentConfirmationExit={slotContentConfirmationExit}
        me={me}
        streams={streams}
        chatInLive
      />
    </>
  );
}
